/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetInventoryMissingFieldResponse
 */
export interface AssetInventoryMissingFieldResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryMissingFieldResponse
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryMissingFieldResponse
     */
    itemId: string | null;
}

/**
 * Check if a given object implements the AssetInventoryMissingFieldResponse interface.
 */
export function instanceOfAssetInventoryMissingFieldResponse(value: object): value is AssetInventoryMissingFieldResponse {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('itemId' in value) || value['itemId'] === undefined) return false;
    return true;
}

export function AssetInventoryMissingFieldResponseFromJSON(json: any): AssetInventoryMissingFieldResponse {
    return AssetInventoryMissingFieldResponseFromJSONTyped(json, false);
}

export function AssetInventoryMissingFieldResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInventoryMissingFieldResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'itemId': json['itemId'],
    };
}

export function AssetInventoryMissingFieldResponseToJSON(json: any): AssetInventoryMissingFieldResponse {
    return AssetInventoryMissingFieldResponseToJSONTyped(json, false);
}

export function AssetInventoryMissingFieldResponseToJSONTyped(value?: AssetInventoryMissingFieldResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'itemId': value['itemId'],
    };
}

